import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Alert, Row, Col } from 'react-bootstrap';
import { FaFilter } from 'react-icons/fa';
import './styles.css';
import Paginator from '~/Components/Paginator';
import Loading from '~/Components/Loading';
import Prospectos from '~/Components/Prospectos/Prospectos';
import Prospecto from '~/Components/Prospectos/ProspectoItem';
import PageQuantitySelector from '~/Components/PageQuantitySelector';
import { CaretDown, UserPlus } from 'phosphor-react';
import PageOrderBy from '~/Components/PageOrderBy';

class ProspectoLista extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modoMobile: window.innerWidth <= 768,
      toggleMenuOrdenacao: false,
    };
    this.handleResize = this.handleResize.bind(this);
  }

  handleResize() {
    this.setState({ modoMobile: window.innerWidth <= 770 });
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    // Garante o estado correto ao montar
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }
  render() {
    const { modoMobile, toggleMenuOrdenacao } = this.state;
    const {
      ProspectoLista,
      isLoadingProspect,
      isErrorProspect,
      pagination,
      history,
      filter,
    } = this.props;
    return (
      <Prospectos className="bg-white">
        {({ doPaginate }) => (
          <div className="container-fluid mb-3 mt-4 bg-white" style={{ maxWidth: 1400 }}>
            <Row>
              {!isLoadingProspect &&
                !isErrorProspect &&
                ProspectoLista.length === 0 && (
                  <Col lg={{ span: 5, offset: 3 }}>
                    <div className="text-center mt-3 ">
                      {Object.keys(filter).length > 0 && (
                        <Alert variant="secondary" className="mb-3 p-3">
                          Nenhum resultado foi encontrado!
                        </Alert>
                      )}
                      <small className="">
                        Clique no botão{' '}
                        <span>
                          <FaFilter
                            size={15}
                            color="#419AEF"
                            style={{
                              stroke: '#fff',
                              strokeWidth: 32,
                              verticalAlign: 'middle',
                              pointerEvents: 'none',
                              cursor: 'default',
                            }}
                          />{' '}
                          <strong className="d-none d-md-inline">
                            Filtros{' '}
                          </strong>
                        </span>
                        para realizar uma
                        <strong> busca</strong> de prospectos
                        <p className="m-0">ou </p>
                        <span>
                          <UserPlus
                            size={15}
                            color="#419AEF"
                            style={{
                              stroke: '#fff',
                              strokeWidth: 32,
                              verticalAlign: 'middle',
                              pointerEvents: 'none',
                              cursor: 'default',
                            }}
                          />
                          <strong className="ml-2 d-none d-md-inline">
                            Adicionar{' '}
                          </strong>
                        </span>
                        para adicionar um novo prospecto
                      </small>
                      <Link
                        to="/prospectos/lista?novo=true"
                        className="btn btn-lg btn-block text-uppercase shadow-lg py-3 mt-3"
                        style={{
                          background: '#419AEF',
                          borderColor: '#419AEF',
                          fontFamily: 'Open Sans, Arial, sans-serif',
                        }}
                      >
                        <UserPlus color="white" size={25} />
                        <span
                          className="ml-2 d-none d-md-inline"
                          style={{ color: '#fff' }}
                        >
                          Adicionar
                        </span>
                      </Link>
                    </div>
                  </Col>
                )}
              <Col xs="12">
                {isLoadingProspect && <Loading />}

                {!isLoadingProspect && isErrorProspect && (
                  <Alert variant="warning">
                    Erro ao carregar os prospectos
                  </Alert>
                )}

                {!isLoadingProspect && !isErrorProspect && (
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div style={{ fontFamily: 'open sans' }}>
                      {pagination.quantidade_prospectos >
                        pagination.quantidade_por_pagina &&
                        `Exibindo ${pagination.quantidade_por_pagina} de ${pagination.quantidade_prospectos} (Página ${pagination.pagina_atual})`}
                      {pagination.quantidade_prospectos > 0 &&
                        pagination.quantidade_prospectos <
                          pagination.quantidade_por_pagina &&
                        `Exibindo ${pagination.quantidade_prospectos} resultados.`}
                    </div>
                  </div>
                )}
              </Col>
            </Row>
            {ProspectoLista && ProspectoLista.length > 0 && (
              <>
                {!modoMobile && !isLoadingProspect && (
                  <Row className="mb-2 mx-0 py-2 align-items-center">
                    <Col xs={1}>
                      <span className="label-header">Prospecto</span>
                    </Col>
                    <Col xs={3} className="d-flex align-items-center">
                      <span className="label-header">Ordenar</span>
                      <CaretDown
                        size={16}
                        className="ml-2"
                        style={{
                          cursor: 'pointer',
                          transition: 'transform 0.3s',
                          transform: toggleMenuOrdenacao
                            ? 'rotate(180deg)'
                            : 'rotate(0deg)',
                        }}
                        onClick={() =>
                          this.setState({
                            toggleMenuOrdenacao: !toggleMenuOrdenacao,
                          })
                        }
                      />
                      <PageOrderBy
                        toggleMenuOrdenacao={toggleMenuOrdenacao}
                        onChange={argument => {
                          doPaginate({ Ordem: argument });
                        }}
                        onClose={() => this.setState({ toggleMenuOrdenacao: false })}
                      />
                    </Col>
                    <Col xs={2} className="text-center">
                      <span className="label-header">Status</span>
                    </Col>
                    <Col xs={2} className="text-left">
                      <span className="label-header">Negociação</span>
                    </Col>
                    <Col xs={2} className="pl-3">
                      <span className="label-header">Empreendimento</span>
                    </Col>
                    <Col xs={2} className="text-center">
                      <span className="label-header">Ações</span>
                    </Col>
                  </Row>
                )}

                {modoMobile && !isLoadingProspect && (
                  <Row className="mb-3 mx-0 align-items-center">
                    <Col className="d-flex align-items-center">
                      <span className="label-header">Ordenar</span>
                      <CaretDown
                        size={16}
                        className="ml-2"
                        style={{
                          cursor: 'pointer',
                          transition: 'transform 0.3s',
                          transform: toggleMenuOrdenacao
                            ? 'rotate(180deg)'
                            : 'rotate(0deg)',
                        }}
                        onClick={() =>
                          this.setState({
                            toggleMenuOrdenacao: !toggleMenuOrdenacao,
                          })
                        }
                      />
                      <PageOrderBy
                        toggleMenuOrdenacao={toggleMenuOrdenacao}
                        onChange={argument => {
                          doPaginate({ Ordem: argument });
                        }}
                        onClose={() => this.setState({ toggleMenuOrdenacao: false })}
                      />
                    </Col>
                    <Col xs="auto">
                      <span className="label-header">Status</span>
                    </Col>
                  </Row>
                )}

                {!isLoadingProspect &&
                  ProspectoLista.map((item, index) => (
                    <Prospecto
                      data={item}
                      key={index}
                      modoMobile={modoMobile}
                    />
                  ))}
                {!isLoadingProspect &&
                  !isErrorProspect &&
                  pagination.quantidade_prospectos >
                    pagination.quantidade_por_pagina && (
                    <div className="clearfix">
                      <div className="float-left">
                        <Paginator
                          numberOfPages={pagination.ultima_pagina || 1}
                          initialPage={pagination.pagina_atual || 1}
                          onPageChange={pagina_atual =>
                            doPaginate({ pagina_atual })
                          }
                        />
                      </div>
                      <div className="float-right">
                        <PageQuantitySelector
                          value={pagination.quantidade_por_pagina}
                          onChange={event =>
                            doPaginate({
                              quantidade_por_pagina: event.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                  )}
              </>
            )}
          </div>
        )}
      </Prospectos>
    );
  }
}

const mapStateToProps = state => ({
  ProspectoLista: state.prospecto.list,
  isLoadingProspect: state.prospecto.isLoading,
  isErrorProspect: state.prospecto.isError,
  pagination: state.prospecto.pagination,
  filter: state.prospecto.filter,
  liberarCadastroProspecto: state.options.liberarCadastroProspecto,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProspectoLista)
);
